export default "__VITE_ASSET__nRq7OKsI__"